module.exports = __webpack_public_path__ + "static/media/kindbody.c29abfee.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/kindbody.svg
// module id = 26
// module chunks = 0